import { cnpj, cpf } from 'cpf-cnpj-validator';

export class AgentDocument {
  private document: string;

  constructor(document: string) {
    this.document = !document ? '' : document.replace(/[^\d]+/g, '');
  }

  isPerson() {
    const isValid = cpf.isValid(this.document, true);
    return isValid;
  }

  isCompany() {
    const isValid = cnpj.isValid(this.document, true);
    return isValid;
  }

  isValid() {
    return this.isPerson()
      ? cpf.isValid(this.document, true)
      : cnpj.isValid(this.document, true);
  }

  getFormated() {
    return this.isPerson()
      ? cpf.format(this.document)
      : cnpj.format(this.document);
  }

  getDocument() {
    return this.document;
  }
}
